import React from 'react';
import { isSet } from '../../../../Utils/CommonFunctions';
import SubFormRows from './SubFormRows';
import { getUserInfo } from '../../../../Utils/UserFunctions';

const SubFormBody = (props) => {
  const {
    subformIndex,
    sectionSubformData,
    pageType,
    modType,
    isWrite,
    section,
    reminderDisplayText,
    shouldRenderButton,
  } = props;

  let sectionData = section?.data || [];
  const userInfo = getUserInfo();
  if (userInfo?.data?.role_name === 'Community Partners') {
    sectionData = (section?.data || []).filter(
      (item) => item.api_custom_field_name !== 'cf_quoted_cost'
    );
  }
  const colCount = sectionData.filter(
    (item) => isSet(item.access_mode, 'EDITABLE') !== 'HIDDEN'
  ).length;

  const rows = sectionSubformData?.subform_rows || [];
  const totalRows = rows.length;

  return (
    <tbody>
      {rows.map((rowData, rowIndex) => (
        <SubFormRows
          key={rowIndex}
          rowIndex={rowIndex}
          sectionData={sectionData}
          rowData={rowData}
          modType={modType}
          isWrite={isWrite}
          updateSubformRow={props.updateSubformRow}
          saveAndUpdateSubform={props.saveAndUpdateSubform}
          sectionSubformData={sectionSubformData}
          pageType={pageType}
          reminderDisplayText={reminderDisplayText}
          section={section}
          removeSubformDataHandler={props.removeSubformDataHandler}
          onChangeInputAction={props.onChangeInputAction}
          subformIndex={subformIndex}
          shouldRenderButton={shouldRenderButton}
          isSelectAll={props.isSelectAll}
          selectData={props.selectHandler}
          onSubformRowAdded={props.onSubformRowAdded}
          sectionType={props.sectionType}
          onSubformActionStart={props.onSubformActionStart}
        />
      ))}
      {totalRows === 0 && (
        <tr>
          <td colSpan={colCount} className="text-center">
            No Record exists
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default SubFormBody;
